module.exports = __webpack_public_path__ + "img/Event.6a6081f1.png";